export enum Spacings {
    xxl = 320,
    xl = 200,
    lg = 150,
    md = 100,
    sm = 32,
    mm = 10,
}
